<template>
    <div class="domain" :class="[{ 'is-loading': is_loading }, { 'is-dark': is_dark }]" @click="open(data.title)">
        <label class="label">{{ data.title }}</label>
        <p>{{ data.desc }}</p>
        <div class="info">
            <div class="url" v-if="$ProjectName === 'sephora' && !is_fallback">
                creators.sephora.com
            </div>
            <div class="url" v-else-if="data.url && !is_dark">{{ (data.url.startsWith('https://')
                || data.url.startsWith('http://')) ? data.url : 'https://' +
                data.url }}</div>
            <div class="text" v-else>{{ data.default_url }}</div>


            <div class="right-info">

                <span :class="[{ 'green-dot': data.is_act === 1, 'yellow-dot': data.is_act === 2, 'red-dot red-dot-btn': data.is_act === 3 }]"
                    v-if="data.act_text && is_dark">{{ data.act_text }}</span>

                <svg-icon name="lock" v-if="is_dark" />

                <div :class="['for-subdomain-bottom']" v-if="is_subdomain && !is_dark && !data.is_btn">
                    <span :class="[{ 'green-dot': data.is_act === 1, 'yellow-dot': data.is_act === 2, 'red-dot red-dot-btn': data.is_act === 3 }]">{{ data.act_text }}</span>
                    <i :class="['icon32', !permission_domain && 'not-allowed-btn']"><svg-icon name="arrow-next" /></i>
                </div>

                <el-button v-if="data.is_btn && !is_dark" :type="!data.url ? 'primary':'default'" :disabled="!permission_domain">{{ data.btn_text }}</el-button>
            </div>
        </div>

    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import { ElButton } from 'element-plus';

export default {
    name: 'DomainEditShowBox',

    components: {
        Button,
        ElButton
    },

    props: {
        data: {
            type: Object,
            default: {
                title: 'Built-in Motom domain',
                desc: 'This is your built-in Motom domain. Your storefront site can always be accessed from this domain and it never expires.',
                url: '',
                default_url: 'Demo: https://www.website.com',
                act_text: 'Active on 17 storefronts and 1 page',
                is_act: true,
                is_btn: false,
                btn_text: 'Add'
            }
        },
        is_loading: {
            type: Boolean,
            default: false
        },
        is_dark: {
            type: Boolean,
            default: false
        },
        is_subdomain: {
            type: Boolean,
            default: false
        },
        is_fallback: {
            type: Boolean,
            default: false
        }
    },

    computed:{
        permission_domain(){
            return this.$store.state.user_data?.permission_list?.settingIntegrations?.domainSettings.permission ===100;
        },
    },

    data() {
        return {

        }
    },

    methods: {
        open(title) {
            if(!this.permission_domain){
                return;
            }
            this.$emit('open', title);
        }
    },

    mounted() {

    },
}
</script>
<style lang="scss">
.not-allowed-btn{
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
}
</style>

